import { Box, Paper, Skeleton } from "@mui/material";

export interface TitledChartSkeletonProps {
  hasButtons?: boolean;
  hasLegend?: boolean;
  legendItemsCount?: number;
  className?: string;
}

const TitledChartSkeleton = ({
  hasButtons = false,
  hasLegend = false,
  legendItemsCount = 5,
  className = "w-full pl-4 pr-2"
}: TitledChartSkeletonProps) => {
  return (
    <Box className={className} sx={{ height: "100%" }}>
      <Paper elevation={1} sx={{ height: "500px", p: 3 }}>
        <Box className="w-full flex gap-6 mb-4">
          {/* Title skeleton */}
          <Skeleton variant="text" width={200} height={40} />
          {/* Toggle buttons skeleton */}
          {hasButtons && <Skeleton variant="rounded" width={80} height={32} />}
        </Box>

        {/* Chart area with optional legend */}
        <Box sx={{ display: "flex", height: "calc(100% - 80px)", gap: 2 }}>
          {/* Chart area skeleton */}
          <Skeleton
            variant="rectangular"
            width={hasLegend ? "calc(100% - 200px)" : "100%"}
            height="100%"
            sx={{ borderRadius: 1 }}
          />

          {/* Legend skeleton */}
          {hasLegend && (
            <Box
              sx={{
                width: "180px",
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
                justifyContent: "center"
              }}
            >
              {Array.from({ length: legendItemsCount }).map((_, index) => (
                <Box
                  key={index}
                  sx={{ display: "flex", alignItems: "center", gap: 1 }}
                >
                  {/* Legend color line */}
                  <Skeleton
                    variant="rectangular"
                    width={15}
                    height={4}
                    sx={{ borderRadius: 1 }}
                  />
                  {/* Legend label */}
                  <Skeleton variant="text" width={100} height={16} />
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default TitledChartSkeleton;
